export type State = 'up' | 'degraded' | 'down' | 'unknown';
export type Overall = 'operational' | 'degraded' | 'major' | 'unknown';

export interface Service {
  id: string;
  name: string;
  kind: 'http' | 'tcp';
  state: State;
  last_probe_at: string | null;
  last_response_ms: number | null;
  last_change_at: string | null;
  uptime_24h: number;
  uptime_30d: number;
}
export interface Group {
  name: string;
  services: Service[];
  /** false for informational groups (sponsored community infrastructure)
   * whose states are excluded from the overall rollup. */
  impacts_overall?: boolean;
}
export interface Incident {
  id: string;
  service_id: string;
  service_name: string;
  group_name: string;
  started_at: string;
  resolved_at?: string | null;
  duration_s?: number | null;
  kind: 'down' | 'degraded';
  note: string | null;
}
export interface StatusPayload {
  overall: Overall;
  updated_at: string;
  groups: Group[];
  active_incidents: Incident[];
}

export interface HistoryBucket { date: string; uptime_pct: number; total: number; up: number; incidents: number }
export interface HistoryPayload {
  service: { id: string; name: string; group: string };
  days: number;
  buckets: HistoryBucket[];
}

export async function fetchStatus(): Promise<StatusPayload> {
  const res = await fetch('/api/status', { cache: 'no-store' });
  if (!res.ok) throw new Error(`status ${res.status}`);
  return res.json();
}
export async function fetchHistory(id: string, days = 90): Promise<HistoryPayload> {
  const res = await fetch(`/api/history/${encodeURIComponent(id)}?days=${days}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`status ${res.status}`);
  return res.json();
}
export async function fetchIncidents(limit = 50): Promise<Incident[]> {
  const res = await fetch(`/api/incidents?limit=${limit}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`status ${res.status}`);
  return res.json();
}
